import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';

const CUSTOMER_SHRINK_PRIORITY = 100;

interface OrderBreadcrumbCustomerProps {
  label: string;
}

const OrderBreadcrumbCustomer = ({ label }: OrderBreadcrumbCustomerProps) => {
  if (!label) {
    return null;
  }

  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', gap: 0.5, minWidth: 0, flexShrink: CUSTOMER_SHRINK_PRIORITY }}
    >
      <Typography variant="subtitle2" sx={{ color: 'text.primary', ml: 0.25 }}>
        ·
      </Typography>
      <Typography variant="subtitle2" noWrap sx={{ color: 'text.tertiary' }}>
        {label}
      </Typography>
    </Stack>
  );
};

export default OrderBreadcrumbCustomer;
